<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:update:success="updateSucess">
  </AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "RentingPreparationForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        products: [{ product_id: null, quantity: null }],
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        product_id_options: _.orderBy(
          this.$store.getters["product/getByStatusSlug"]('product_on_sale').selectOptions("id", "name"),
          "text"
        ),
      };
    },
  },
  mounted() {
    let self = this;

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            products: [],
          };
          item.products_renting.forEach((product) => {
            self.form.products.push({
              product_id: product.product.id,
              quantity: product.quantity,
            });
          });
          item.products_selling.forEach((product) => {
            self.form.products.push({
              product_id: product.product.id,
              quantity: product.quantity,
            });
          });

          this.isBusy = false;
        });
    }

    this.$store.dispatch("product/getAllForSelect");
  },
  methods: {
    updateSucess() {
      this.$store
        .dispatch("renting/getItem", {
          id: this.form.renting.id,
          wait: true,
        })
        .then(() => {
          let renting = this.$store.getters["renting/getItem"](this.form.renting.id)
          if (renting.renting_preparations.length == 0) {
            this.$store
              .dispatch("renting/deleteItem", this.form.renting.id)
              .then((response) => {
                toastr.success("La commande ne possède plus de préparation et a donc été supprimée automatiquement");
                this.$router.push({
                  name: 'RentingList',
                });
              })
              .catch((error) => {
                this.$toastr.error(
                  "La commande ne possède plus de préparation, mais sa suppression automatique a échouée. Veuillez l'annuler ou contacter un administrateur"
                );
              });
          }
          this.$root.$emit("bv::hide::modal", "renting_preparation_form");
        })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RentingPreparation/RentingPreparationForm.vue